var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoHover01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.77 8.38a11 11 0 0 0-.72-1.6 10 10 0 0 0-.6-1 11.89 11.89 0 0 0-3.24-3.24 11 11 0 0 0-2.57-1.32 12 12 0 0 0-8.26 0 11.38 11.38 0 0 0-1.6.78c-.33.19-.66.39-1 .6a12.21 12.21 0 0 0-2.54 2.26c-.24.3-.47.61-.69.92a10 10 0 0 0-.6 1A12 12 0 0 0 2 18.22a10 10 0 0 0 .6 1c.22.31.45.62.69.92a12.21 12.21 0 0 0 2.55 2.31c.31.21.64.41 1 .6a11.38 11.38 0 0 0 1.59.72 12 12 0 0 0 8.26 0 11 11 0 0 0 2.57-1.32 11.89 11.89 0 0 0 3.24-3.24 10 10 0 0 0 .6-1 11 11 0 0 0 .72-1.6 12 12 0 0 0 0-8.24ZM12.5 21.5a9 9 0 1 1 9-9 9 9 0 0 1-9 9Zm-.76-13.64a1.56 1.56 0 0 1-.48-1.13 1.54 1.54 0 0 1 .48-1.13 1.58 1.58 0 0 1 1.14-.48 1.64 1.64 0 0 1 1.6 1.61 1.6 1.6 0 0 1-1.6 1.61 1.58 1.58 0 0 1-1.14-.48ZM14 16h2v2h-6v-2h1v-5h-1V9h4Z",
    style: {
      fill: "#48c0ea"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoHover01);
export default __webpack_public_path__ + "static/media/info-hover-01.4d728f51cd2101459d3c6bf5cdad3015.svg";
export { ForwardRef as ReactComponent };